import { apiClient } from './client';

/**
 * Placeholder — full payment surface (approve/reject deposit/withdrawal, manual ops)
 * lives in Fase 3. See ARCHITECTURE.md §2.4 + KNOWLEDGE.md §7.
 */
export const paymentsApi = {
  list: async (
    params: { kind?: 'deposit' | 'withdrawal'; type?: 'deposit' | 'withdrawal'; status?: string; clientId?: string } = {},
  ) => {
    // el backend espera `kind` (no `type`); mantenemos `type` por compat con retiros.tsx
    const { type, ...rest } = params;
    const query = { ...rest, ...(type ? { kind: type } : {}) };
    const { data } = await apiClient.get('/admin/payments', { params: query });
    return data;
  },

  approve: async (id: string) => {
    const { data } = await apiClient.post(`/admin/payments/${id}/approve`);
    return data;
  },

  reject: async (id: string, reason: string) => {
    const { data } = await apiClient.post(`/admin/payments/${id}/reject`, { reason });
    return data;
  },

  /**
   * F3 — cierra manualmente un retiro trabado en atención donde el jugador YA fue debitado (o hay
   * una transferencia posiblemente en vuelo). NO re-acredita nada: es la constancia del operador de
   * que ya verificó en SmartCobro qué pasó. `note` es obligatoria (mín. 3 caracteres).
   */
  resolveAttention: async (id: string, note: string) => {
    const { data } = await apiClient.post(`/admin/payments/${id}/resolve-attention`, { note });
    return data;
  },
};
